export const renderApprovalStatus = (code: string) => {
  switch (code) {
    case '0':
      return { text: '상신', color: 'slate' as const };
    case '1':
      return { text: '보류', color: 'amber' as const };
    case '2':
      return { text: '진행중', color: 'green' as const };
    case '3':
      return { text: '완료', color: 'blue' as const };
    case '4':
      return { text: '반려', color: 'red' as const };
    default:
      return { text: '상신', color: 'slate' as const };
  }
};

// 결재상태
export const renderLineStatus = (code: string) => {
  switch (code) {
    case '0':
      return { text: '미승인', color: 'slate' as const };
    case '1':
      return { text: '보류', color: 'amber' as const };
    case '2':
      return { text: '승인', color: 'blue' as const };
    case '3':
      return { text: '반려', color: 'red' as const };
    default:
      return { text: '미승인', color: 'slate' as const };
  }
};

// 결재자 처리 상태(caLstatus) 0: 대기, 1: 보류, 2: 승인, 3: 반려
const CA_LSTATUS_WAITING = '0';

/**
 * 결재 목록에서 '결재 대기' 라벨을 붙일 건인지 판단한다.
 * currentUserId(서버가 내려주는 현재 결재 대기자)만 보면 보류처럼 내가 이미 처리한 뒤에도
 * 차례가 유지되는 상태에서 라벨이 계속 붙어, 실제 문서 상태(보류/완료/반려)를 가린다.
 * 그래서 내 차례인지에 더해 결재선의 내 처리 상태가 '대기'인지까지 확인한다.
 */
export const isAwaitingApprovalFrom = (userId: string, currentUserId: string, approvalLine?: { userId: string; caLstatus: string }[]) => {
  if (!userId || currentUserId !== userId) return false;
  return approvalLine?.find((line) => line.userId === userId)?.caLstatus === CA_LSTATUS_WAITING;
};

/** 처리 상태 검색 옵션 '결재 대기'. 공통코드에 없는 화면 전용 값이라 문서 상태 코드(0~4)와 겹치지 않게 둔다 */
export const AWAITING_MY_APPROVAL_CODE = 'W';

/** 공통코드 처리 상태 목록의 '전체' 바로 뒤에 '결재 대기' 옵션을 끼워 넣는다 */
export const withAwaitingMyApprovalOption = <T extends Record<string, any>>(statusList: T[] | undefined, comCd: string) => {
  if (!statusList) return statusList;
  const awaitingOption = { type: comCd, [comCd]: AWAITING_MY_APPROVAL_CODE, cdName: '결재 대기' } as unknown as T;
  const allIndex = statusList.findIndex((el) => el[comCd] === 'A');
  return [...statusList.slice(0, allIndex + 1), awaitingOption, ...statusList.slice(allIndex + 1)];
};
